module.exports = __webpack_public_path__ + "static/media/small-modsy-logo.9382a9a8.svg";